// @flow
import Cookie from 'js-cookie'

export const getAuthToken = () => Cookie.get('token')

export default getAuthToken
